import { styled } from '@linaria/react';
import { colors, fonts } from '../../theme/tokens';

export const StyledTextButton = styled.button`
  font-family: ${fonts.body};
  font-weight: ${fonts.weight.medium};
  color: ${colors.fontPrimary};
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  text-decoration: underline;
  font-size: ${fonts.size.sm};

  &[data-size='xs'] {
    font-size: ${fonts.size.xs};
  }

  &:hover {
    color: ${colors.secondary};
  }
`;
